import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserShield } from "@fortawesome/free-solid-svg-icons";
import { useMyDetails } from "../../hooks/useMyDetails";
import "./eventManager.css";

/**
 * The header's single way into the admin page, for every active staff member.
 *
 * Not gated on the publishing permissions: a manager approving the first step
 * of their team's events holds none of them, and this link is the only in-app
 * way to their queue. The page itself narrows what each person sees to their
 * own submissions and queue, and the API enforces who may decide anything.
 */
export const AdminNav: React.FC = () => {
	const { hasAdminAccess } = useMyDetails();
	if (!hasAdminAccess) return null;
	return (
		<Link className="em-navbar-link" to="/admin">
			<FontAwesomeIcon icon={faUserShield} /> Event admin
		</Link>
	);
};
